interface ContactSupportProps {
  onShowModalChange: (newShowModalState: boolean) => void;
  telNumber: number;
}

const ContactSupport: React.FC<ContactSupportProps> = ({
  onShowModalChange,
  telNumber,
}) => {
  const handlePhoneClick = () => {
    const phoneNumber = `tel:021 ${telNumber}`;
    window.location.href = phoneNumber;
  };

  return (
    <div className="relative w-[255px] lg:w-[355px] shadow-button_sm_hover h-[238px]  overflow-hidden bg-white border border-gray-100 rounded-lg ">
      <div className="w-full pl-4 pt-2 flex items-center justify-between">
        <span className="invisible">Close modal</span>
        <svg
          className="w-3 h-3 hover:cursor-pointer"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
          onClick={() => onShowModalChange(false)}
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </div>
      <div className="grid  mt-5 items-center justify-center">
        <div className="grid items-center justify-center w-[64px] h-[64px] bg-primary-100 rounded-full mx-auto">
          <img src="/icons/headphones.svg" alt="user" />
        </div>
        <label className="text-Title/14/Regular mt-6 ">
          شماره تماس با پشتیبانی
        </label>
        <label
          className="text-Title/20/Bold mt-6 cursor-pointer "
          onClick={handlePhoneClick}
          dir="ltr"
        >
          ۰۲۱ - {telNumber}
        </label>
      </div>
    </div>
  );
};

export default ContactSupport;
